import { EcoFeeLoader } from './EcoFeeLoader';
import { EcoFeeLoaderInterface } from './interface';

export const ecoFeeLoader: { (token?: string): EcoFeeLoaderInterface } = (token) =>
  new EcoFeeLoader(token);
